import React, { useEffect } from 'react'

import LotImageViewerContainer from '../components/lot-image-viewer/LotImageViewerContainer'
import GlobalModals from '../components/layout/GlobalModals'

export default props => {

    // useEffect(() => {
    //     console.log('LOT IMAGE VIEWER SCREEN', props)
    // })

    return (<div>
        <LotImageViewerContainer {...props} />
        <GlobalModals />
    </div>)
}
